module.exports = __webpack_public_path__ + "static/s4-bg-3b6ae7752a9d43cdca87dc1c83aeecd2.png";